<template>
  <footer
    class="text-center d-flex align-items-center justify-content-center bg-secondary mt-auto"
  >
    <p class="text-white m-0 p-2">
      Built with <i class="bi bi-heart-fill text-danger"></i> by
      <a href="https://github.com/gkyla" class="text-white" target="_blank"
        >gkyla</a
      >
    </p>
  </footer>
</template>

<script>
export default {

};
</script>

<style>
</style>
